<template>
	
	<div class="mb-3">
		<div class="font-weight-medium pt-0 mb-3">{{field.name}}</div>
		<div v-show="imageReady !== true">
			<v-file-input ref="fileInput" label="Select image" outlined dense></v-file-input>
			<v-btn class="ml-9 mt-n4" small @click="uploadFile">Upload</v-btn>
			<v-progress-linear class="mb-9 mt-5" v-model="uploadProgress" value="0"></v-progress-linear>
		</div>
		<div v-if="imageReady === true" class="d-flex flex-row">
			<v-img
				:src="previewImageSrc"
				width="250"
				height="125"
				style="max-width: 250px;"
				class="grey darken-4"
            ></v-img>
			<v-btn class="ml-3" @click="removeImage">Remove</v-btn>
			<v-spacer/>
		</div>

	</div>

</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

//import agile from "@/shift/agile";
import fb from '@/shift/fb';
import agile from "@/shift/agile";



export default
{
	name: 'ContentFieldSimpleImage',

	// ----------------------------------
	//	VUE: Data, properties, etc.
	// ----------------------------------

	props:
	{
		field: { type: Object },
	},

	data: () =>
	({
		uploadProgress: 0,
		tempImage: null,
		tempFile: null,
		previewImageSrc: '',
		imageReady: false,
		storageReference: null,
	}),

	computed:
	{
        agile()
        {
            return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		},
	},

	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{
		if (this.field.data && this.field.data.src)
		{
			const dataValue = this.field.data;

			if (dataValue)
			{
				this.field.value = dataValue;
				this.setImageSrc();
			}
			
		}
		
		//https://firebasestorage.googleapis.com/v0/b/agile-shift-genesis.appspot.com/o/SunCloud.jpg?alt=media
	},

	mounted()
	{
		this.$refs.fileInput.$on('change', this.onFileChosen);
	},


	// ----------------------------------------------------
	//
	//  VUE: Methods
	//
	// ----------------------------------------------------

	methods:
	{
		removeImage()
		{
			this.imageReady = false;
			
		},

		onFileChosen(file)
		{
			this.tempFile = file;

			
			// Use file reader to get dimensions of image
			var fr = new FileReader();
    
			fr.onload = () =>
			{
				var img = new Image();
				
				img.onload = () =>
				{
					// Prepend file with 5 random number to prevent file name collision
					const path = 'content/'+this.routeKey+'/'+this.field.actualId+'/'+agile.random5DigitString()+file.name;

					this.tempImage = //routeKey
					{
						src: encodeURIComponent(path),//'content/'+this.routeKey+'/'+agile.usl()+this.field.actualId+agile.usl()+file.name,
						path: path,//'content/'+this.field.actualId+'/'+file.name,
						size: file.size,
						width: img.width,
						height: img.height,
					}
				};
				
				img.src = fr.result;
			};
			
			fr.readAsDataURL(file);

		},

		uploadFile()
		{

			if (this.tempImage && this.tempImage.src)
			{
				this.storageReference = fb.storage.ref(this.tempImage.path);
				const task = this.storageReference.put(this.tempFile);
				task.on('state_changed', this.onProgress, this.onError, this.onComplete);
			}
			else
			{
				this.$root.$alert('Choose image', 'You must browser for an image to upload first :-)');
			}
		},


		onProgress(snapshot)
		{
			const percent = (snapshot.bytesTransferred / snapshot.totalBytes)*100;
			this.uploadProgress = percent;
		},

		onError(err)
		{
			console.log('File upload error:', err);
		},

		async onComplete()
		{
			
			this.field.value = this.tempImage;

			/*const promises = [];
			const userUpdateResults = await Promise.all(promises);

			promises.push(*/

			this.storageReference.getDownloadURL().then((url) =>
			{
				this.field.value.src = url
				this.setImageSrc();
				//console.log('eee', url)
				//return url;
			}).catch(function(err) {
				console.log('er', err)
			});

			//this.setImageSrc();
		},

		setImageSrc()
		{
			this.previewImageSrc = this.field.value.src;//'https://firebasestorage.googleapis.com/v0/b/hofseth-ae6f4.appspot.com/o/'+this.field.value.src+'?alt=media';
			this.imageReady = true;
		}



	},


	beforeDestroy()
	{
		
		this.$refs.fileInput.$off('change', this.onFileChosen);
	},

}

</script>

